/**
 * TanStack Query hooks for `fraudscore-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	fraudscoreIntegrationQueryKeys,
	type CreateFraudscoreIntegrationBody,
	type ListFraudscoreIntegrationResponse,
	type FraudscoreIntegrationRow,
} from "./api";

export function useFraudscoreIntegrationList(): UseQueryResult<ListFraudscoreIntegrationResponse, Error> {
	return useQuery({
		queryKey: fraudscoreIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useFraudscoreIntegrationCreate(): UseMutationResult<FraudscoreIntegrationRow, Error, CreateFraudscoreIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudscoreIntegrationQueryKeys.all });
		},
	});
}

export function useFraudscoreIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudscoreIntegrationQueryKeys.all });
		},
	});
}
